// extracted by mini-css-extract-plugin
export default {"BookCreate":"BookCreate_BookCreate__q6fEU","FormControl":"BookCreate_FormControl__YrCwK"};